<div class="row my">
    <div class="col-md-12 ">
        <div class="p-3 ScrollStyle">

            <div class="crd p-2 act " [ngClass]="{'select':value=='PayG'}">
                <a [routerLink]="['/pay-g']">
                    <div class="row  " (click)="menues('PayG')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/new logo.svg" class="icons  " alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='PayG'}" *ngIf="english">PayG</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='PayG'}" *ngIf="hindi">पे
                                जी</label>
                        </div>
                    </div>
                </a>
            </div>

            <div class="crd p-2 act " [ngClass]="{'select':value=='features'}">
                <a [routerLink]="['/features']">
                    <div class="row " (click)="menues('features')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/paygfeatures.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='features'}"  *ngIf="english">PayG Features</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='features'}"  *ngIf="hindi"> पे जी फीचर्स </label>
                        </div>
                    </div>
                </a>
            </div>

            <div class="crd p-2 act">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/Payment Gateway.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('4')" >
                        <label for="" class="cur "  *ngIf="english">Payment Gateway</label>
                        <label for="" *ngIf="hindi">पेमेंट गेटवे</label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('4')" *ngIf="up3">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down3">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='4'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/']">
                                        <div class="   " [ngClass]="{'child':value=='Payment Gateway'}">
                                            <li (click)="menues('Payment Gateway')" class="cur"
                                                [ngClass]="{'color':value=='Payment Gateway'}" *ngIf="english">
                                                Introduction to Payment Gateway
                                            </li>
                                            <li (click)="menues('Payment Gateway')" class="cur "
                                                [ngClass]="{'color':value=='Payment Gateway'}" *ngIf="hindi">
                                                पेमेंट गेटवे का परिचय
                                            </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/payment-gateway-working']">
                                        <div class="mt-3   " [ngClass]="{'child':value=='Payment Gateway Working'}">
                                            <li (click)="menues('Payment Gateway Working')" class="cur "
                                                [ngClass]="{'color':value=='Payment Gateway Working'}" *ngIf="english">
                                                Payment Gateway Industry's Working
                                            </li>
                                            <li class=" mt-3" (click)="menues('Payment Gateway Working')" class="cur"
                                                [ngClass]="{'color':value=='Payment Gateway Working'} " *ngIf="hindi">

                                                पेमेंट गेटवे उद्योग की कार्यप्रणाली
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="crd p-2 act " [ngClass]="{'select':value=='onboarding'}">
                <a [routerLink]="['/onboarding']">
                    <div class="row " (click)="menues('onboarding')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/onboarding.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='onboarding'}"  *ngIf="english"> Onboarding Process</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='onboarding'}"  *ngIf="hindi"> ऑनबोर्डिंग प्रक्रिया </label>
                        </div>
                    </div>
                </a>
            </div>

            <div class="crd p-2 act " [ngClass]="{'select':value=='Merchant-Dashboard'}">
                <a [routerLink]="['/merchant-dashboard']">
                    <div class="row  cursor " (click)="menues('Merchant-Dashboard')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/merchantdashboard.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Merchant-Dashboard'}"
                                *ngIf="english">Merchant-Dashboard</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Merchant-Dashboard'}"
                                *ngIf="hindi">व्यापारी डैशबोर्ड
                            </label>

                        </div>
                    </div>
                </a>
            </div>
            <!-- <div class="crd p-2 act " [ngClass]="{'select':value=='PayG'}">
                <a [routerLink]="['/pay-g']">
                    <div class="row  " (click)="menues('PayG')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/new logo.svg" class="icons  " alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='PayG'}" *ngIf="english">PayG</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='PayG'}" *ngIf="hindi">पे
                                जी</label>
                        </div>
                    </div>
                </a>
            </div> -->
            <div class="crd p-2 act " [ngClass]="{'select':value=='E-Agreement'}">
                <a [routerLink]="['/e-agrement']">
                    <div class="row  " (click)="menues('E-Agreement')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/E-agreement.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='E-Agreement'}"
                                *ngIf="english">E-Agreement</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='E-Agreement'}"
                                *ngIf="hindi">ई-एग्रीमेंट</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Web Integration'}">
                <a [routerLink]="['/web-integration']">
                    <div class="row  " (click)="menues('Web Integration')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/web integration.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Web Integration'}" *ngIf="english">Web
                                Integration</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Web Integration'}" *ngIf="hindi">वेब
                                इंटीग्रेशन</label>
                        </div>
                    </div>
                </a>
            </div>

            <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/payout.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('5')" (click)="menues('reseller')">
                        <label for="" class="cur" *ngIf="english">Sales Partner</label>
                        <label for="" class="cur" *ngIf="hindi">पुनर्विक्रेता </label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('5')" *ngIf="up3">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down3">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='5'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/sales-partner']">
                                        <div class="   " [ngClass]="{'child':value=='reseller'}">
                                            <li (click)="menues('reseller')" class="cur"
                                                [ngClass]="{'color':value=='reseller'}" *ngIf="english">
                                                Introduction to Sales Partner
                                            </li>
                                            <li (click)="menues('Introduction Reseller')" class="cur"
                                            [ngClass]="{'color':value=='reseller-intro-hindi'}" *ngIf="hindi">
                                            पुनर्विक्रेता का परिचय
                                        </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/sales-partner-registration']">
                                        <div class="   " [ngClass]="{'child':value=='registration-process'}">
                                            <li (click)="menues('registration-process')" class="cur mt-3"
                                                [ngClass]="{'color':value=='registration-process'}" *ngIf="english">
                                                Registration Process
 
                                            </li>
                                            <li (click)="menues('reseller-registration')" class="cur mt-3"
                                                [ngClass]="{'color':value=='reseller-registration'}" *ngIf="hindi">
                                                पंजीकरण प्रक्रिया
                                            </li>
                                        </div>
                                    </a>

                                    <a [routerLink]="['/sales-partner-QR']">
                                        <div class="   " [ngClass]="{'child':value=='login-with-qr'}">
                                            <li (click)="menues('login-with-qr')" class="cur mt-3"
                                                [ngClass]="{'color':value=='login-with-qr'}" *ngIf="english">
                                                Login Process with QR
 
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                क्यूआर के साथ लॉगिन प्रक्रिया
                                            </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/sales-partner-manual']">
                                        <div class="   " [ngClass]="{'child':value=='manual-login'}">
                                            <li (click)="menues('manual-login')" class="cur mt-3"
                                                [ngClass]="{'color':value=='manual-login'}" *ngIf="english">
                                                Login Process with OTP
 
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                ओटीपी के साथ लॉगिन प्रक्रिया
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/Payment link.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('1')" >
                        <label for="" class="cur" *ngIf="english">Payment Link</label>
                        <label for="" *ngIf="hindi">पेमेंट लिंक</label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('1')" *ngIf="up">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='1'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/payment-link']">
                                        <div class="   " [ngClass]="{'child':value=='Payment Link'}">
                                            <li (click)="menues('Payment Link')" class="cur"
                                                [ngClass]="{'color':value=='Payment Link'}" *ngIf="english">
                                                Introduction to Payment Link
                                            </li>
                                            <li (click)="menues('Payment Link')" class="cur"
                                                [ngClass]="{'color':value=='Payment Link'}" *ngIf="hindi">
                                                पेमेंट लिंक का परिचय
                                            </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/create-link']">
                                        <div class="mt-3   " [ngClass]="{'child':value=='Create Payment'}">
                                            <li (click)="menues('Create Payment')" class="cur"
                                                [ngClass]="{'color':value=='Create Payment'}" *ngIf="english">
                                                How
                                                to Create Payment Link?
                                            </li>
                                            <li class=" mt-3" (click)="menues('Create Payment')" class="cur"
                                                [ngClass]="{'color':value=='Create Payment'} " *ngIf="hindi">

                                                पेमेंट लिंक कैसे क्रिएट करें
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='G-Store'}">
                <a [routerLink]="['/g-store']">
                    <div class="row " (click)="menues('G-Store')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/g-store.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='G-Store'}"
                                *ngIf="english">G-Store</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='G-Store'}"
                                *ngIf="hindi">जी-स्टोर</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Pay Button'}">
                <a [routerLink]="['/pay-button']">
                    <div class="row " (click)="menues('Pay Button')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/pay button.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Pay Button'}" *ngIf="english">Pay
                                Button</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Pay Button'}" *ngIf="hindi">पे
                                बटन</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Payment QR'}">
                <a [routerLink]="['/payment-qr']">
                    <div class="row " (click)="menues('Payment QR')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Payment QR.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Payment QR'}" *ngIf="english">Payment
                                QR</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Payment QR'}" *ngIf="hindi">पेमेंट
                                क्यूआर</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Invoice'}">
                <a [routerLink]="['/invoice']">
                    <div class="row " (click)="menues('Invoice')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Invoice.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Invoice'}"
                                *ngIf="english">Invoice</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Invoice'}"
                                *ngIf="hindi">इनवॉइस</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Video KYC'}">
                <a [routerLink]="['/video-kyc']">
                    <div class="row " (click)="menues('Video KYC')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Video KYc.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Video KYC'}"  *ngIf="english">Video
                                KYC</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Video KYC'}"  *ngIf="hindi">वीडियो केवाईसी</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Transactions'}">
                <a [routerLink]="['/transaction']">
                    <div class="row " (click)="menues('Transactions')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Transactions.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Transactions'}"  *ngIf="english">Transactions</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Transactions'}"  *ngIf="hindi">ट्रांजेक्शन</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Refunds'}">
                <a [routerLink]="['/refunds']">
                    <div class="row " (click)="menues('Refunds')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Refunds.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Refunds'}" *ngIf="english">Refunds</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Refunds'}" *ngIf="hindi">रिफंड</label>

                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Disputes'}">
                <a [routerLink]="['/disputes']">
                    <div class="row " (click)="menues('Disputes')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Disputes.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Disputes'}"  *ngIf="english">Disputes</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Disputes'}"  *ngIf="hindi">डिस्प्यूट्स</label>
                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/payprofile.svg" class="icons" alt="">
                    </div>
                       <div class="col-md-8 mt-1" (click)="subMenu('2')" >
                        <label for="" class="cur" *ngIf="english">Pay Profile</label>
                        <label for="" class="cur" *ngIf="hindi">पे प्रोफाईल</label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('2')" *ngIf="up1">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down1">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='2'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/pay-profile']">
                                        <div class="   " [ngClass]="{'child':value=='Pay Profile'}">
                                            <li class="" (click)="menues('Pay Profile')" class="cur"
                                                [ngClass]="{'color':value=='Pay Profile'}" *ngIf="english" >
                                                Introduction to Pay Profile
                                            </li>
                                            
                                            <li class="" (click)="menues('Pay Profile')" class="cur"
                                                [ngClass]="{'color':value=='Pay Profile'}" *ngIf="hindi">
                                                पे प्रोफाईल का परिचय
                                            </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/easy-collect']">
                                        <div class="   " [ngClass]="{'child':value=='Easy Collect'}">
                                            <li class="" (click)="menues('Easy Collect')" class="cur mt-3 "
                                                [ngClass]="{'color':value=='Easy Collect'}" *ngIf="english">
                                                How to Create Easy Collect?
                                            </li>
                                            <li class="" (click)="menues('Easy Collect')" class="cur mt-3 "
                                            [ngClass]="{'color':value=='Easy Collect'}" *ngIf="hindi">
                                            ईजी कलेक्ट केसे क्रिएट करे
                                        </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/smart-collect']">
                                        <div class="   " [ngClass]="{'child':value=='smart collect'}">
                                            <li class="" (click)="menues('smart collect')" class="cur mt-3"
                                                [ngClass]="{'color':value=='smart collect'}" *ngIf="english"> 
                                                How to Create Smart Collect Profile
                                            </li>
                                            
                                            <li class="" (click)="menues('smart collect')" class="cur mt-3"
                                                [ngClass]="{'color':value=='smart collect'}" *ngIf="hindi">
                                                स्मार्ट कलेक्ट प्रोफाइल कैसे बनाएं
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Booking and ticketing hidding for now  -->
             
            <!-- <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/booking&ticketing.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('3')" (click)="menues('Booking & Ticketing')">
                        <label for="" class="cur" *ngIf="english">Booking and Ticketing </label>
                        <label for="" class="cur" *ngIf="hindi">बुकिंग और टिकटिंग </label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('3')" *ngIf="up2">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down2">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='3'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/booking-tecketing']">
                                        <div class="   " [ngClass]="{'child':value=='Booking & Ticketing'}">
                                            <li (click)="menues('Booking & Ticketing')" class="cur"
                                                [ngClass]="{'color':value=='Booking & Ticketing'}" *ngIf="english">
                                                Introduction to Booking & Ticketing
                                            </li>
                                            <li (click)="menues('Booking & Ticketing')" class="cur"
                                            [ngClass]="{'color':value=='Booking & Ticketing'}" *ngIf="hindi">
                                            बुकिंग और टिकटिंग का परिचय
                                        </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/create-profile']">
                                        <div class="   " [ngClass]="{'child':value=='Creating Profile'}">
                                            <li (click)="menues('Creating Profile')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Creating Profile'}" *ngIf="english">
                                                Creating Profile
                                            </li>
                                            <li (click)="menues('Creating Profile')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Creating Profile'}" *ngIf="hindi">
                                                प्रोफाईल केसे क्रिएट करे
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->



            <!-- <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/payout.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('4')" (click)="menues('Payout')">
                        <label for="" class="cur" *ngIf="english">Payout</label>
                        <label for="" class="cur" *ngIf="hindi">पे आउट </label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('4')" *ngIf="up3">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down3">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='4'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/pay-out']">
                                        <div class="   " [ngClass]="{'child':value=='Payout'}">
                                            <li (click)="menues('Payout')" class="cur"
                                                [ngClass]="{'color':value=='Payout'}" *ngIf="english">
                                                Introduction to  PayOut
                                            </li>
                                            <li (click)="menues('Payout')" class="cur"
                                            [ngClass]="{'color':value=='Payout'}" *ngIf="hindi">
                                            पे आउट का परिचय
                                        </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/create-payout']">
                                        <div class="   " [ngClass]="{'child':value=='Create-Payout'}">
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="english">
                                               How to Create Payout
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                पे आउट कैसे बनाएं
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
            <!--<div class="crd p-2 act " [ngClass]="{'select':value=='Payout'}">
                <a [routerLink]="['/pay-out']">
                    <div class="row " (click)="menues('Payout')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Payout Logo Color 1.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Payout'}"  *ngIf="english">PayOut</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Payout'}"  *ngIf="hindi">पे आउट</label>
                        </div>
                    </div>
                    
                </a>    
            </div>-->
            <!-- <div class="crd p-2 act " [ngClass]="{'select':value=='onboarding'}">
                <a [routerLink]="['/onboarding']">
                    <div class="row " (click)="menues('onboarding')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/onboarding.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='onboarding'}"  *ngIf="english"> Onboarding Process</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='onboarding'}"  *ngIf="hindi"> ऑनबोर्डिंग प्रक्रिया </label>
                        </div>
                    </div>
                </a>
            </div> -->
           
            <!-- <div class="crd p-2 act " [ngClass]="{'select':value=='features'}">
                <a [routerLink]="['/features']">
                    <div class="row " (click)="menues('features')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/paygfeatures.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='features'}"  *ngIf="english">PayG Features</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='features'}"  *ngIf="hindi"> पे जी फीचर्स </label>
                        </div>
                    </div>
                </a>
            </div> -->

           <!--<div class="crd p-2 act " [ngClass]="{'select':value=='coupons'}">
                <a [routerLink]="['/coupons']">
                    <div class="row " (click)="menues(' coupons')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Coupon.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='coupons'}"  *ngIf="english"> Coupons</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='coupons'}"  *ngIf="hindi"> कूपन </label>
                        </div>
                    </div>
                </a>
            </div>--> 
            <!--<div class="crd p-2 act " [ngClass]="{'select':value=='price'}">
                <a [routerLink]="['/price']">
                    <div class="row " (click)="menues(' price')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Price match.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='price'}"  *ngIf="english"> Price Match</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='price'}"  *ngIf="hindi"> मूल्य मिलान </label>
                        </div>
                    </div>
                </a>
            </div>-->
            <!--<div class="crd p-2 act " [ngClass]="{'select':value=='Settlement'}">
                <a [routerLink]="['/settlement']">
                    <div class="row " (click)="menues(' Settlement')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Settlement Split.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">
                            <label for="" class="cur" [ngClass]="{'color':value=='Settlement'}"  *ngIf="english"> Settlement Split</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Settlement'}"  *ngIf="hindi"> सेटलमेंट </label>
                        </div>
                    </div>
                </a>
            </div>-->
            <div class="crd p-2 act " [ngClass]="{'select':value=='Coupons'}">
                <a [routerLink]="['/coupons']">
                    <div class="row  cursor " (click)="menues('Coupons')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/coupons.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Coupons'}"
                                *ngIf="english">Coupons</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Coupons'}"
                                *ngIf="hindi">कूपन </label>

                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Price'}">
                <a [routerLink]="['/price']">
                    <div class="row  cursor " (click)="menues('Price')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/Price match.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Price'}"
                                *ngIf="english">Price Match</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Price'}"
                                *ngIf="hindi">मूल्य मिलान  </label>

                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Settlement'}">
                <a [routerLink]="['/settlement']">
                    <div class="row  cursor " (click)="menues('Settlement')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/settlement.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Settlement'}"
                                *ngIf="english">Settlement</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Settlement'}"
                                *ngIf="hindi">सेटलमेंट </label>

                        </div>
                    </div>
                </a>
            </div>
            <div class="crd p-2 act " [ngClass]="{'select':value=='Reports'}">
                <a [routerLink]="['/report']">
                    <div class="row  cursor " (click)="menues('Reports')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/report.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Reports'}"
                                *ngIf="english">Reports </label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Reports'}"
                                *ngIf="hindi">रिपोर्टस </label>

                        </div>
                    </div>
                </a>
            </div>
            <!-- <div class="crd p-2 act " [ngClass]="{'select':value=='Merchant-Dashboard'}">
                <a [routerLink]="['/merchant-dashboard']">
                    <div class="row  cursor " (click)="menues('Merchant-Dashboard')">
                        <div class="col-md-2">
                            <img src="./assets/Payg Icons/merchantdashboard.svg" class="icons" alt="">
                        </div>
                        <div class="col-md-10 mt-1">    
                            <label for="" class="cur" [ngClass]="{'color':value=='Merchant-Dashboard'}"
                                *ngIf="english">Merchant-Dashboard</label>
                            <label for="" class="cur" [ngClass]="{'color':value=='Merchant-Dashboard'}"
                                *ngIf="hindi">व्यापारी डैशबोर्ड
                            </label>

                        </div>
                    </div>
                </a>
            </div> -->
            <!-- <div class="crd p-2 act ">
                <div class="row  ">
                    <div class="col-md-2">
                        <img src="./assets/Payg Icons/payout.svg" class="icons" alt="">
                    </div>
                    <div class="col-md-8 mt-1" (click)="subMenu('5')" (click)="menues('reseller')">
                        <label for="" class="cur" *ngIf="english">Reseller</label>
                        <label for="" class="cur" *ngIf="hindi">पे आउट </label>
                    </div>
                    <div class="col-md-2 mt-1" (click)="subMenu('5')" *ngIf="up3">
                        <img src="./assets/Dropdown.svg" alt="">
                    </div>
                    <div class="col-md-2 mt-1" (click)="close()" *ngIf="down3">
                        <img src="./assets/Dropdown up.svg" alt="">
                    </div>
                    <div class="col-md-12 " *ngIf="child=='5'">
                        <div class="row  submenu">
                            <div class="col-md-12 mt-1 p-2">
                                <ul>
                                    <a [routerLink]="['/introduction-reseller']">
                                        <div class="   " [ngClass]="{'child':value=='introduction-reseller'}">
                                            <li (click)="menues('introduction-reseller')" class="cur"
                                                [ngClass]="{'color':value=='introduction-reseller'}" *ngIf="english">
                                                Introduction to Reseller
                                            </li>
                                            <li (click)="menues('introduction-reseller')" class="cur"
                                            [ngClass]="{'color':value=='introduction-reseller'}" *ngIf="hindi">
                                            पे आउट का परिचय
                                        </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/registration-process']">
                                        <div class="   " [ngClass]="{'child':value=='registration-process'}">
                                            <li (click)="menues('registration-process')" class="cur mt-3"
                                                [ngClass]="{'color':value=='registration-process'}" *ngIf="english">
                                                Registration Process
 
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                पंजीकरण प्रक्रिया
                                            </li>
                                        </div>
                                    </a>

                                    <a [routerLink]="['/login-with-qr']">
                                        <div class="   " [ngClass]="{'child':value=='login-with-qr'}">
                                            <li (click)="menues('login-with-qr')" class="cur mt-3"
                                                [ngClass]="{'color':value=='login-with-qr'}" *ngIf="english">
                                                Login Process with QR
 
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                ....
                                            </li>
                                        </div>
                                    </a>
                                    <a [routerLink]="['/manual-login']">
                                        <div class="   " [ngClass]="{'child':value=='manual-login'}">
                                            <li (click)="menues('manual-login')" class="cur mt-3"
                                                [ngClass]="{'color':value=='manual-login'}" *ngIf="english">
                                                Login Process with OTP
 
                                            </li>
                                            <li (click)="menues('Create-Payout')" class="cur mt-3"
                                                [ngClass]="{'color':value=='Create-Payout'}" *ngIf="hindi">
                                                पंजीकरण प्रक्रिया
                                            </li>
                                        </div>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>